module.exports = [
    "$uibModalInstance",
    "$uibModal",
    "toast",
    "item",
    "pages",
    "formDefinition",
    "canSeeAdditionalHistoryFields",
    "Authentication",
    "$http",
    "$timeout",
    "$q",
    "$translate",
    function (
        $uibModalInstance,
        $uibModal,
        toast,
        item,
        pages,
        formDefinition,
        canSeeAdditionalHistoryFields,
        Authentication,
        $http,
        $timeout,
        $q,
        $translate
    ) {
        var _this = this;
        this.item = item;
        this.pages = (formDefinition?.validate_pages?.length ? formDefinition.validate_pages : pages) || [];
        this.formPages = formDefinition?.pages || [];
        this.canSeeAdditionalHistoryFields = canSeeAdditionalHistoryFields;

        this.convertDurationTextToTime = function (texto) {
            if (!texto) return "";
            const dias = /(\d+)\s*d[ií]as?/.exec(texto);
            const horas = /(\d+)\s*horas?/.exec(texto);
            const minutos = /(\d+)\s*minutos?/.exec(texto);
            const segundos = /(\d+)\s*segundos?/.exec(texto);
            const diasNum = dias ? parseInt(dias[1], 10) : 0;
            const horasNum = horas ? parseInt(horas[1], 10) : 0;
            const minutosNum = minutos ? parseInt(minutos[1], 10) : 0;
            const segundosNum = segundos ? parseInt(segundos[1], 10) : 0;
            const totalHoras = diasNum * 24 + horasNum;
            return "".concat(
                totalHoras.toString().padStart(2, "0"),
                ":",
                minutosNum.toString().padStart(2, "0"),
                ":",
                segundosNum.toString().padStart(2, "0")
            );
        };

        this.buildDisplayFieldContext = function (fieldData, fieldDef) {
            const templateData = fieldDef?.templateData || fieldData?.templateData || {};
            const type = fieldData?.type || fieldDef?.type;
            return {
                type,
                value: fieldData?.value,
                templateData,
                onlyLabel: fieldDef?.onlyLabel ?? fieldData?.onlyLabel,
                convertTo: fieldDef?.convertTo ?? templateData?.convertTo ?? fieldData?.convertTo,
                convertToTime: fieldDef?.convertToTime ?? templateData?.convertToTime ?? fieldData?.convertToTime,
            };
        };

        this.formatNumberLikeValue = function (value, fieldDef) {
            if (value == null || value === "") return "";
            let field = fieldDef || { type: "number", templateData: {} };
            const fieldType = field.type || "number";
            let templateData = { ...(field.templateData || {}) };

            if (fieldType === "formula" && templateData.maxDecimalsCount == null && templateData.formula?.decimals != null) {
                templateData = { ...templateData, maxDecimalsCount: templateData.formula.decimals };
            }
            field = { ...field, templateData };

            if (fieldType === "autonumeric") {
                const strVal = String(value).trim();
                if (!/^-?\d+(\.\d+)?$/.test(strVal)) return strVal;
            }

            if (fieldType === "formula" && templateData.isAdvanced) {
                return String(value);
            }

            if (typeof window.maskValue === "function" && ["number", "formula"].includes(fieldType)) {
                const masked = window.maskValue(value, field);
                if (masked !== "" && masked != null) return masked;
            }

            const numericValue = parseFloat(value);
            if (isNaN(numericValue)) return String(value);

            let fractionDigits = null;
            if (templateData.forceDecimals) {
                if (fieldType === "formula" && typeof templateData.formula?.decimals === "number") {
                    fractionDigits = templateData.formula.decimals;
                } else if (typeof templateData.maxDecimalsCount === "number") {
                    fractionDigits = templateData.maxDecimalsCount;
                }
            }

            let num = numericValue;
            if (fractionDigits != null) {
                num = parseFloat(num.toFixed(fractionDigits));
            }

            if (templateData.thousandSeparator) {
                return new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: templateData.forceDecimals && fractionDigits != null ? fractionDigits : 0,
                    maximumFractionDigits: templateData.forceDecimals && fractionDigits != null ? fractionDigits : 20,
                }).format(num);
            }

            if (fractionDigits != null) return num.toFixed(fractionDigits);
            return String(num);
        };

        this.formatSelectLikeValue = function (value) {
            if (value == null || value === "") return "";
            if (Array.isArray(value)) {
                return value
                    .map(v => this.formatSelectLikeValue(v))
                    .filter(Boolean)
                    .join(", ");
            }
            if (typeof value === "object") {
                return value.name || value.label || value.value || JSON.stringify(value);
            }
            if (typeof value === "string") {
                const pipeIdx = value.indexOf("|");
                return pipeIdx >= 0 ? value.substr(pipeIdx + 1) : value;
            }
            return String(value);
        };

        this.formatFieldValueForDisplay = function (fieldData, fieldDef) {
            if (!fieldData) return "";

            const ctx = this.buildDisplayFieldContext(fieldData, fieldDef);
            const fieldType = ctx.type;
            const value = ctx.value;

            if (value == null && fieldType !== "checkbox") return "";

            if (fieldType === "simplelist" && Array.isArray(value)) {
                return "".concat(value.length, " registro(s)");
            }
            if (fieldType === "docs" && Array.isArray(value)) {
                return "".concat(value.length, " documento(s)");
            }
            if (["photo", "video"].includes(fieldType) && Array.isArray(value)) {
                return value
                    .map(file => file?.name || file?.uri || "")
                    .filter(Boolean)
                    .join(", ");
            }
            if (Array.isArray(value)) {
                if (value.some(v => v && typeof v === "object")) {
                    return "".concat(value.length, " elemento(s)");
                }
                if (fieldType === "multiple") {
                    return this.formatSelectLikeValue(value);
                }
                return value
                    .map(v => {
                        if (v == null) return "";
                        if (typeof v === "object") return v.name || v.label || v.uri || JSON.stringify(v);
                        return String(v);
                    })
                    .filter(Boolean)
                    .join(", ");
            }

            if (fieldType === "date" && value) {
                const dateValue = new Date(value);
                return isNaN(dateValue.getTime()) ? "" : dateValue.toLocaleDateString("af");
            }
            if (fieldType === "time" && value) {
                const timeValue = new Date(value);
                return isNaN(timeValue.getTime()) ? "" : timeValue.toLocaleTimeString("af");
            }
            if (fieldType === "timestamp" && value) {
                const tsValue = new Date(value);
                if (isNaN(tsValue.getTime())) return "";
                if (typeof tsValue.getYYYYMMddHHmmss === "function") {
                    return tsValue.getYYYYMMddHHmmss();
                }
                return tsValue.toLocaleString("af");
            }
            if (fieldType === "duration" && ctx.convertToTime && value) {
                return this.convertDurationTextToTime(String(value));
            }
            if (fieldType === "checkbox") {
                if (ctx.convertTo) {
                    switch (ctx.convertTo) {
                        case "SI/NO": return value === true ? "SI" : "NO";
                        case "1/0": return value === true ? "1" : "0";
                        case "VERDADERO/FALSO": return value === true ? "VERDADERO" : "FALSO";
                        default: break;
                    }
                }
                return value ? "Si" : "No";
            }
            if (fieldType === "geo" && value) {
                return "".concat(
                    value.coords?.latitude || "",
                    ",",
                    value.coords?.longitude || ""
                );
            }
            if (["select", "multiple"].includes(fieldType)) {
                return this.formatSelectLikeValue(value);
            }
            if (["number", "autonumeric", "formula"].includes(fieldType)) {
                return this.formatNumberLikeValue(value, fieldDef || fieldData);
            }
            if (fieldType === "sign" && value) {
                if (typeof value === "string") return value;
                return value.uri || value.url || JSON.stringify(value);
            }

            if (typeof value === "object") {
                return value.name || value.label || value.uri || JSON.stringify(value);
            }
            return value;
        };

        this.getValueByType = function (field, fieldDef) {
            return this.formatFieldValueForDisplay(field, fieldDef || field);
        };

        this.isDocsFieldData = function (fieldDef, fieldData) {
            if (!fieldData) return false;
            if (fieldDef?.type === "docs" || fieldData?.type === "docs") return true;
            const value = fieldData.value;
            if (!Array.isArray(value) || value.length === 0) return false;
            return value.every(v => {
                if (typeof v === "string") return true;
                return v && (v.uri || v.fileUrl);
            });
        };

        this.isNestedFieldData = function (fieldDef, fieldData) {
            if (!fieldData || this.isDocsFieldData(fieldDef, fieldData)) return false;
            if (fieldDef?.type === "simplelist" || fieldData?.type === "simplelist") return true;
            const value = fieldData.value;
            if (Array.isArray(value)) {
                return value.some(v => v && typeof v === "object");
            }
            return false;
        };

        this.formatValidationFieldValue = function (fieldId, fieldData) {
            const fieldDef = this.lookupFieldDefinition(fieldId, this.fieldDefMap);
            return this.formatFieldValueForDisplay(fieldData, fieldDef);
        };

        this.flattenValidateNodes = function (nodes) {
            const flattened = [];
            if (!nodes) return flattened;

            const nodesList = Array.isArray(nodes)
                ? nodes
                : Object.keys(nodes).map(key => nodes[key]);

            nodesList.forEach(node => {
                if (!node) return;
                if (node.type === "group") {
                    const groupChildren = Array.isArray(node.nodes)
                        ? node.nodes
                        : (node.nodes ? Object.keys(node.nodes).map(k => node.nodes[k]) : []);
                    groupChildren.forEach(child => {
                        if (child?.id) flattened.push(child);
                    });
                    return;
                }
                if (node.id) flattened.push(node);
            });

            return flattened;
        };

        this.GENERIC_TYPE_LABELS = {
            docs: ["documents", "documentos", "document", "documento", "docs"],
            photo: ["photos", "fotos", "photo", "foto"],
            video: ["videos", "video"],
            sign: ["sign", "firma", "signature"],
            text: ["text", "texto"],
            formula: ["formula", "fórmula", "formulas", "fórmulas"],
            title: ["title", "titulo", "título"],
            geo: ["geo", "geolocation", "geolocalización", "geolocalizacion"],
            simplelist: ["simplelist", "lista simple", "lista"],
            group: ["group", "grupo"],
            select: ["select", "selección", "seleccion", "selection"],
            multiple: ["multiple", "múltiple", "multiple"],
            checkbox: ["checkbox"],
            number: ["number", "numero", "número"],
            timestamp: ["timestamp"],
            date: ["date", "fecha"],
            time: ["time", "hora"],
        };

        this.isMeaningfulFieldLabel = function (label, fieldType) {
            if (label == null || label === "") return false;
            const normalized = label.toString().trim().toLowerCase();
            if (!normalized) return false;
            const generics = this.GENERIC_TYPE_LABELS[fieldType] || [];
            if (generics.includes(normalized)) return false;
            if (fieldType && normalized === fieldType.toLowerCase()) return false;
            return true;
        };

        this.extractDisplayLabel = function (meta) {
            if (!meta || typeof meta !== "object") return "";
            const fieldType = meta.type;
            const pickMeaningful = value => {
                if (!value) return "";
                return this.isMeaningfulFieldLabel(value, fieldType) ? value : "";
            };
            const direct = pickMeaningful(meta.label)
                || pickMeaningful(meta.name)
                || pickMeaningful(meta.title)
                || pickMeaningful(meta.text);
            if (direct) return direct;
            const templateData = meta.templateData;
            if (templateData && typeof templateData === "object") {
                return pickMeaningful(templateData.label)
                    || pickMeaningful(templateData.name)
                    || pickMeaningful(templateData.title)
                    || "";
            }
            return "";
        };

        this.registerFieldDefAliases = function (fieldDefMap, fieldId, fieldDef) {
            if (!fieldId || !fieldDef) return;
            fieldDefMap[fieldId] = fieldDef;
            const cleanFieldId = fieldId.replace(/^validate_/, "");
            if (cleanFieldId !== fieldId) fieldDefMap[cleanFieldId] = fieldDef;
            const prefixedFieldId = "validate_".concat(cleanFieldId);
            if (prefixedFieldId !== fieldId && prefixedFieldId !== cleanFieldId) {
                fieldDefMap[prefixedFieldId] = fieldDef;
            }
        };

        this.walkDynamicFormFields = function (pageList, onField, options) {
            const opts = options || {};
            const walkFields = fields => {
                if (!Array.isArray(fields)) return;
                fields.forEach(field => {
                    if (!field || !field.id) return;
                    if (field.type === "group") {
                        walkFields(field.nodes || field.fields);
                        return;
                    }
                    onField(field, opts.addToOrder !== false);
                    if (field.type === "simplelist" && field.nodes) {
                        this.flattenValidateNodes(field.nodes).forEach(node => {
                            if (node?.id) onField(node, false);
                        });
                    }
                });
            };
            (pageList || []).forEach(page => walkFields(page?.fields));
        };

        this.normalizeFieldDefinition = function (field) {
            const displayLabel = this.extractDisplayLabel(field);
            const normalized = { ...field, displayLabel };
            if (displayLabel) {
                normalized.name = displayLabel;
                normalized.label = displayLabel;
            } else {
                if (!this.isMeaningfulFieldLabel(normalized.name, field.type)) {
                    normalized.name = undefined;
                }
                if (!this.isMeaningfulFieldLabel(normalized.label, field.type)) {
                    normalized.label = undefined;
                }
            }
            return normalized;
        };

        this.isFieldHiddenFromGrid = function (fieldDef) {
            if (!fieldDef) return false;
            const hideGrid = fieldDef.templateData?.hideGrid;
            return hideGrid == true;
        };

        this.isNumericFieldType = function (fieldType) {
            return ["number", "formula", "autonumeric"].includes(fieldType);
        };

        this.buildSimpleListColumnMeta = function (simpleListFieldDef, nodeId, order, subItems) {
            const payloadEntry = this.getPayloadEntryForSimpleListKey(subItems, nodeId);
            const resolved = this.resolveSimpleListNodeDef(simpleListFieldDef, nodeId);
            const fieldType = resolved?.type || payloadEntry?.type;
            return {
                id: nodeId,
                order,
                label: this.getFieldLabel(nodeId, this.fieldDefMap),
                isNumeric: this.isNumericFieldType(fieldType),
            };
        };

        this.resolveSimpleListNodeDef = function (simpleListFieldDef, nodeId) {
            if (!nodeId) return null;
            const cleanNodeId = nodeId.replace(/^validate_/, "");
            const fromMap = this.lookupFieldDefinition(nodeId, this.fieldDefMap)
                || this.lookupFieldDefinition(cleanNodeId, this.fieldDefMap);

            const fromNodes = this.getSimpleListRelevantNodes(simpleListFieldDef?.nodes).find(node => {
                if (!node?.id) return false;
                const cleanId = node.id.replace(/^validate_/, "");
                return node.id === nodeId || node.id === cleanNodeId
                    || cleanId === cleanNodeId || cleanId === nodeId;
            });

            if (fromNodes && fromMap) {
                return {
                    ...fromNodes,
                    ...fromMap,
                    templateData: {
                        ...(fromNodes.templateData || {}),
                        ...(fromMap.templateData || {}),
                    },
                };
            }
            return fromNodes || fromMap || null;
        };

        /** Misma expansión de nodos que simpleListValidateDirective (grupos → hijos). */
        this.getSimpleListRelevantNodes = function (nodes) {
            const allNodes = [];
            if (!nodes) return allNodes;

            const nodesList = Array.isArray(nodes)
                ? nodes
                : Object.keys(nodes).map(key => nodes[key]);

            nodesList.forEach(node => {
                if (!node) return;
                if (node.type === "group" && node.nodes && node.nodes.length > 0) {
                    const children = Array.isArray(node.nodes)
                        ? node.nodes
                        : Object.keys(node.nodes).map(k => node.nodes[k]);
                    allNodes.push(...this.getSimpleListRelevantNodes(children));
                    return;
                }
                allNodes.push(node);
            });

            return allNodes;
        };

        this.isSimpleListUseAsTitle = function (simpleListFieldDef, nodeId, payloadEntry) {
            const resolved = this.resolveSimpleListNodeDef(simpleListFieldDef, nodeId);
            if (resolved?.templateData?.useAsTitle == true) return true;
            if (payloadEntry?.templateData?.useAsTitle == true) return true;
            return false;
        };

        this.shouldShowSimpleListColumn = function (simpleListFieldDef, nodeId, payloadEntry) {
            const resolved = this.resolveSimpleListNodeDef(simpleListFieldDef, nodeId);
            if (this.isFieldHiddenFromGrid(resolved)) return false;
            return this.isSimpleListUseAsTitle(simpleListFieldDef, nodeId, payloadEntry);
        };

        this.getPayloadEntryForSimpleListKey = function (subItems, key) {
            for (const subItem of (subItems || [])) {
                if (!subItem || typeof subItem !== "object") continue;
                if (subItem[key] != null) return subItem[key];
                const cleanKey = key.replace(/^validate_/, "");
                if (subItem[cleanKey] != null) return subItem[cleanKey];
            }
            return null;
        };

        this.buildSimpleListDetailColumns = function (simpleListFieldDef, subItems) {
            const titleNodes = this.getSimpleListRelevantNodes(simpleListFieldDef?.nodes);
            const explicitColumns = [];
            const normalizedNodeMap = {};

            titleNodes.forEach((nodeDef, idx) => {
                const nodeId = nodeDef?.id;
                if (!nodeId) return;

                const payloadEntry = this.getPayloadEntryForSimpleListKey(subItems, nodeId);
                if (!this.shouldShowSimpleListColumn(simpleListFieldDef, nodeId, payloadEntry)) return;

                const resolvedNodeDef = this.resolveSimpleListNodeDef(simpleListFieldDef, nodeId) || nodeDef;
                const cleanNodeId = nodeId.replace(/^validate_/, "");
                const prefixedNodeId = "validate_".concat(cleanNodeId);

                [nodeId, cleanNodeId, prefixedNodeId].forEach(alias => {
                    if (!alias) return;
                    normalizedNodeMap[alias] = resolvedNodeDef;
                });

                explicitColumns.push(this.buildSimpleListColumnMeta(simpleListFieldDef, nodeId, idx, subItems));
            });

            if (explicitColumns.length === 0 && simpleListFieldDef?.nodes) {
                const topLevelNodes = Array.isArray(simpleListFieldDef.nodes)
                    ? simpleListFieldDef.nodes
                    : Object.keys(simpleListFieldDef.nodes).map(k => simpleListFieldDef.nodes[k]);
                const firstNode = topLevelNodes[0];
                if (firstNode?.id) {
                    const resolved = this.resolveSimpleListNodeDef(simpleListFieldDef, firstNode.id) || firstNode;
                    if (!this.isFieldHiddenFromGrid(resolved)) {
                        const col = this.buildSimpleListColumnMeta(simpleListFieldDef, firstNode.id, 0, subItems);
                        explicitColumns.push(col);
                        normalizedNodeMap[firstNode.id] = resolved;
                    }
                }
            }

            if (explicitColumns.length === 0 && subItems?.length) {
                const fallbackKeys = [];
                subItems.forEach(subItem => {
                    if (!subItem || typeof subItem !== "object") return;
                    Object.keys(subItem).forEach(key => {
                        const entry = subItem[key];
                        if (entry?.type === "group" && !Object.prototype.hasOwnProperty.call(entry, "value")) return;
                        if (!fallbackKeys.includes(key)) fallbackKeys.push(key);
                    });
                });

                fallbackKeys.forEach((nodeId, idx) => {
                    const payloadEntry = this.getPayloadEntryForSimpleListKey(subItems, nodeId);
                    if (!this.shouldShowSimpleListColumn(simpleListFieldDef, nodeId, payloadEntry)) return;
                    explicitColumns.push(this.buildSimpleListColumnMeta(simpleListFieldDef, nodeId, idx, subItems));
                });
            }

            return {
                subColumns: explicitColumns
                    .sort((a, b) => a.order - b.order)
                    .map(col => ({ id: col.id, label: col.label, isNumeric: col.isNumeric })),
                normalizedNodeMap,
            };
        };

        this.buildFieldDefinitionMap = function () {
            const map = {};
            const orderedIds = [];
            const registerField = (field, addToOrder) => {
                const normalized = this.normalizeFieldDefinition(field);
                this.registerFieldDefAliases(map, field.id, normalized);
                if (addToOrder && !this.isFieldHiddenFromGrid(normalized)) {
                    orderedIds.push(field.id);
                }
            };

            this.walkDynamicFormFields(this.pages, (field, addToOrder) => registerField(field, addToOrder !== false));
            this.walkDynamicFormFields(this.formPages, field => registerField(field, false), { addToOrder: false });

            return { map, orderedIds };
        };

        this.enrichFieldDefinitionMap = function (fieldDefMap) {
            const addMeta = (fieldId, meta) => {
                if (!fieldId || !meta || meta.type === "group") return;
                const displayLabel = this.extractDisplayLabel(meta);
                const hasLabel = !!displayLabel;
                if (!fieldDefMap[fieldId]) {
                    if (hasLabel || meta.type) {
                        const def = {
                            id: fieldId,
                            name: meta.name || displayLabel,
                            label: meta.label || displayLabel,
                            title: meta.title,
                            type: meta.type,
                            graphColumn: meta.graphColumn,
                            templateData: meta.templateData,
                            displayLabel,
                        };
                        this.registerFieldDefAliases(fieldDefMap, fieldId, def);
                    }
                } else {
                    const def = fieldDefMap[fieldId];
                    if (hasLabel) {
                        def.name = def.name || meta.name || displayLabel;
                        def.label = def.label || meta.label || displayLabel;
                        def.title = def.title || meta.title;
                        def.displayLabel = def.displayLabel || displayLabel;
                    }
                    def.type = def.type || meta.type;
                    def.graphColumn = def.graphColumn || meta.graphColumn;
                    if (!def.templateData && meta.templateData) def.templateData = meta.templateData;
                }
            };
            Object.keys(this.item?.payload || {}).forEach(fieldId => {
                addMeta(fieldId, this.item.payload[fieldId]);
            });
            (this.dataValidations || []).forEach(validation => {
                Object.keys(validation?.payload || {}).forEach(fieldId => {
                    addMeta(fieldId, validation.payload[fieldId]);
                });
            });
        };

        this.buildValidateFieldsTypeRegistry = function () {
            const ordered = [];
            this.walkDynamicFormFields(this.pages, field => {
                if (field.type === "group") return;
                ordered.push({
                    id: field.id,
                    type: field.type || "text",
                    label: this.extractDisplayLabel(field),
                });
            });

            const registry = {};
            ordered.forEach(field => {
                if (!registry[field.type]) registry[field.type] = { named: [], unnamed: [] };
                const bucket = registry[field.type];
                const entry = { id: field.id, label: field.label, orderIdx: bucket.named.length + bucket.unnamed.length };
                if (field.label) bucket.named.push(entry);
                else bucket.unnamed.push(entry);
            });
            return registry;
        };

        /** Formularios dinámicos: ids nuevos sin título heredan labels de campos del mismo tipo en validate_pages. */
        this.applyDynamicFieldLabelFallback = function (fieldDefMap) {
            const typeRegistry = this.buildValidateFieldsTypeRegistry();
            const resolveFieldType = (fieldId, entry) => {
                const def = fieldDefMap[fieldId];
                return entry?.type || def?.type || "text";
            };
            const orderIndexForType = (type, fieldId) => {
                const bucket = typeRegistry[type];
                if (!bucket) return 9999;
                const namedIdx = bucket.named.findIndex(f => f.id === fieldId);
                if (namedIdx >= 0) return namedIdx;
                const unnamedIdx = bucket.unnamed.findIndex(f => f.id === fieldId);
                if (unnamedIdx >= 0) return bucket.named.length + unnamedIdx;
                return 9999;
            };

            (this.dataValidations || []).forEach(validation => {
                const payload = validation?.payload || {};
                Object.keys(typeRegistry).forEach(type => {
                    const bucket = typeRegistry[type];
                    if (!bucket.named.length) return;

                    const payloadUnnamed = Object.keys(payload)
                        .filter(fieldId => {
                            const entry = payload[fieldId];
                            if (resolveFieldType(fieldId, entry) !== type) return false;
                            if (entry?.type === "group" || fieldDefMap[fieldId]?.type === "group") return false;
                            return !this.extractDisplayLabel(entry)
                                && !this.extractDisplayLabel(fieldDefMap[fieldId]);
                        })
                        .sort((a, b) => orderIndexForType(type, a) - orderIndexForType(type, b));

                    if (!payloadUnnamed.length) return;

                    const assignCount = Math.min(payloadUnnamed.length, bucket.named.length);
                    payloadUnnamed.slice(0, assignCount).forEach((fieldId, idx) => {
                        if (!fieldDefMap[fieldId]) {
                            const stub = { id: fieldId, type };
                            this.registerFieldDefAliases(fieldDefMap, fieldId, stub);
                        }
                        const def = fieldDefMap[fieldId];
                        if (!this.extractDisplayLabel(def)) {
                            const inherited = bucket.named[idx].label;
                            def.name = inherited;
                            def.label = inherited;
                            def.displayLabel = inherited;
                        }
                    });
                });
            });
        };

        this.lookupFieldDefinition = function (fieldId, fieldDefMap) {
            if (!fieldId) return null;
            const cleanFieldId = fieldId.replace(/^validate_/, "");
            return fieldDefMap?.[fieldId]
                || fieldDefMap?.[cleanFieldId]
                || fieldDefMap?.["validate_".concat(cleanFieldId)];
        };

        this.getFieldLabel = function (fieldId, fieldDefMap, payloadEntry) {
            const entryLabel = this.extractDisplayLabel(payloadEntry);
            if (entryLabel) return entryLabel;

            const cleanFieldId = (fieldId || "").replace(/^validate_/, "");
            const itemField = this.item?.payload?.[fieldId]
                || this.item?.payload?.[cleanFieldId]
                || this.item?.payload?.["validate_".concat(cleanFieldId)];
            const itemLabel = this.extractDisplayLabel(itemField);
            if (itemLabel) return itemLabel;

            const validationField = this.lookupFieldDefinition(fieldId, fieldDefMap);
            if (validationField && validationField.type !== "group") {
                const defLabel = this.extractDisplayLabel(validationField);
                if (defLabel) return defLabel;
            }

            for (const validation of (this.dataValidations || [])) {
                const vEntry = validation?.payload?.[fieldId]
                    || validation?.payload?.[cleanFieldId]
                    || validation?.payload?.["validate_".concat(cleanFieldId)];
                const vLabel = this.extractDisplayLabel(vEntry);
                if (vLabel) return vLabel;
            }

            return fieldId;
        };

        this.dataValidations = [];
        if (this.item.validate && this.item.validate.length) {
            this.dataValidations = this.item.validate;
        }
        if (this.item.validate_canceled && this.item.validate_canceled.length) {
            this.dataValidations = (this.dataValidations || [])
                .concat(this.item.validate_canceled)
        }

        this.dataValidations = this.dataValidations
            .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : a.updatedAt > b.updatedAt ? -1 : 0))
            .map(validation => ({ ...validation }));

        const fieldDefInfo = this.buildFieldDefinitionMap();
        const fieldDefMap = fieldDefInfo.map;
        this.enrichFieldDefinitionMap(fieldDefMap);
        this.applyDynamicFieldLabelFallback(fieldDefMap);
        this.fieldDefMap = fieldDefMap;
        const fieldMap = {};
        this.dataValidations.forEach(validation => {
            const validationPayload = validation?.payload || {};
            Object.keys(validationPayload).forEach(fieldId => {
                if (!fieldMap[fieldId]) {
                    const payloadEntry = validationPayload?.[fieldId];
                    const fieldDef = fieldDefMap?.[fieldId];
                    if (fieldDef?.type === "group" || payloadEntry?.type === "group") return;
                    if (this.isFieldHiddenFromGrid(fieldDef || fieldDefMap[fieldId])) return;
                    const isDocs = this.isDocsFieldData(fieldDef, payloadEntry);
                    const isNested = this.isNestedFieldData(fieldDef, payloadEntry);
                    fieldMap[fieldId] = {
                        id: fieldId,
                        label: this.getFieldLabel(fieldId, fieldDefMap, payloadEntry),
                        fieldDef: fieldDef || fieldDefMap[fieldId],
                        isDocs,
                        isNested,
                        isNumeric: this.isNumericFieldType(
                            (fieldDef || fieldDefMap[fieldId])?.type || payloadEntry?.type
                        ),
                    };
                }
            });
        });
        if (this.canSeeAdditionalHistoryFields) {
            this.validationFieldColumns = [];
            (fieldDefInfo.orderedIds || []).forEach(fieldId => {
                if (fieldMap[fieldId]) {
                    this.validationFieldColumns.push(fieldMap[fieldId]);
                    delete fieldMap[fieldId];
                }
            });
            this.validationFieldColumns = this.validationFieldColumns.concat(
                Object.values(fieldMap).filter(col => !this.isFieldHiddenFromGrid(col.fieldDef))
            );
        } else {
            this.validationFieldColumns = [];
        }

        this.dataValidations = this.dataValidations.map(validation => {
            const validationPayload = validation?.payload || {};
            const validationPayloadValues = {};
            this.validationFieldColumns.forEach(field => {
                validationPayloadValues[field.id] = this.formatValidationFieldValue(field.id, validationPayload?.[field.id]);
            });

            return {
                ...validation,
                updatedAtFormatted: validation.updatedAt ? new Date(validation.updatedAt)?.getYYYYMMddHHmmss() : "",
                canceledAtFormatted: validation.canceledAt ? new Date(validation?.canceledAt)?.getYYYYMMddHHmmss() : "",
                validationPayloadValues,
            };
        });

        this.getValidationPayloadEntry = function (validationRow, fieldColumn) {
            const fieldId = fieldColumn?.id;
            const fieldDef = fieldColumn?.fieldDef;
            const validationPayload = validationRow?.payload || {};
            const cleanFieldId = (fieldId || "").replace(/^validate_/, "");
            let payloadEntry = validationPayload[fieldId];
            if (payloadEntry == null) payloadEntry = validationPayload[cleanFieldId];
            if (payloadEntry == null) payloadEntry = validationPayload["validate_".concat(cleanFieldId)];
            if (payloadEntry == null && fieldDef?.id) {
                const cleanDefId = fieldDef.id.replace(/^validate_/, "");
                payloadEntry = validationPayload[fieldDef.id]
                    || validationPayload[cleanDefId]
                    || validationPayload["validate_".concat(cleanDefId)];
            }
            if (payloadEntry == null) {
                const matchedKey = Object.keys(validationPayload).find(key => key.replace(/^validate_/, "") === cleanFieldId);
                if (matchedKey) payloadEntry = validationPayload[matchedKey];
            }
            return payloadEntry;
        };

        this.extractSubItems = function (entry) {
            if (Array.isArray(entry)) return entry;
            if (!entry) return [];
            if (Array.isArray(entry.value)) return entry.value;
            if (entry.value && Array.isArray(entry.value.value)) return entry.value.value;
            if (typeof entry.value === "string") {
                try {
                    const parsed = JSON.parse(entry.value);
                    if (Array.isArray(parsed)) return parsed;
                    if (parsed && Array.isArray(parsed.value)) return parsed.value;
                } catch (e) { }
            }
            if (typeof entry === "string") {
                try {
                    const parsed = JSON.parse(entry);
                    if (Array.isArray(parsed)) return parsed;
                    if (parsed && Array.isArray(parsed.value)) return parsed.value;
                } catch (e) { }
            }
            return [];
        };

        this.getNestedDetailCount = function (validationRow, fieldColumn) {
            const payloadEntry = this.getValidationPayloadEntry(validationRow, fieldColumn);
            return this.extractSubItems(payloadEntry).length;
        };

        this.normalizeDocsList = function (entry) {
            return this.extractSubItems(entry).map(doc => {
                if (typeof doc === "string") {
                    const filename = doc.split("/").pop().split("?")[0];
                    return { uri: doc, name: filename || "Documento" };
                }
                if (doc?.uri) {
                    return { uri: doc.uri, name: doc.name || doc.fileName || "Documento" };
                }
                if (doc?.fileUrl) {
                    return { uri: doc.fileUrl, name: doc.fileName || doc.filename || "Documento" };
                }
                return null;
            }).filter(Boolean);
        };

        this.getDocsForColumn = function (validationRow, fieldColumn) {
            const payloadEntry = this.getValidationPayloadEntry(validationRow, fieldColumn);
            let docs = this.normalizeDocsList(payloadEntry);
            if (docs.length > 0) return docs;

            // Fallback 1: documentos adjuntos de validación/cancelación/rechazo
            docs = this.normalizeDocsList(validationRow?.docs);
            if (docs.length > 0) return docs;

            // Fallback 2: valor actual del campo docs en el item
            const fieldId = fieldColumn?.id;
            const cleanFieldId = (fieldId || "").replace(/^validate_/, "");
            const currentDocsEntry = this.item?.payload?.[fieldId] || this.item?.payload?.[cleanFieldId];
            docs = this.normalizeDocsList(currentDocsEntry);
            return docs;
        };

        this.getDocsCount = function (validationRow, fieldColumn) {
            return this.getDocsForColumn(validationRow, fieldColumn).length;
        };

        this.openDocsModal = function (validationRow, fieldColumn) {
            const docs = this.getDocsForColumn(validationRow, fieldColumn);
            if (!docs.length) return;

            $uibModal.open({
                animation: true,
                templateUrl: "directives/gridDocsDirective.html",
                controller: ["$uibModalInstance", "docs", "$http", "$timeout", "$q", "Authentication", "toast", "$translate",
                    function ($uibModalInstance, docs, $http, $timeout, $q, Authentication, toast, $translate) {
                        var modalCtrl = this;
                        modalCtrl.docs = docs;
                        modalCtrl.downloading = false;
                        modalCtrl.downloadProgress = 0;

                        modalCtrl.getDownloadUrl = function (doc) {
                            if (!doc?.uri) return "";
                            const docToken = Authentication.currentDocToken();
                            if (!docToken || doc.uri.indexOf("access_token=") >= 0) return doc.uri;
                            return doc.uri + (doc.uri.indexOf("?") >= 0 ? "&" : "?") + "access_token=" + docToken;
                        };

                        modalCtrl.downloadFile = function (doc) {
                            const deferred = $q.defer();
                            $http({
                                method: "GET",
                                url: modalCtrl.getDownloadUrl(doc),
                                responseType: "blob",
                            }).then(function (response) {
                                const blob = new Blob([response.data], { type: response.headers("Content-Type") || "application/octet-stream" });
                                const link = document.createElement("a");
                                link.href = window.URL.createObjectURL(blob);
                                link.download = doc.name || "documento";
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(link.href);
                                deferred.resolve();
                            }).catch(function (error) {
                                console.error("Error descargando el archivo:", error);
                                toast.error(($translate.instant("No se pudo descargar el archivo: ") || "No se pudo descargar el archivo: ") + (doc.name || ""));
                                deferred.reject(error);
                            });
                            return deferred.promise;
                        };

                        modalCtrl.downloadAll = function () {
                            modalCtrl.downloading = true;
                            modalCtrl.downloadProgress = 0;
                            const downloadNext = function (index) {
                                if (index >= modalCtrl.docs.length) {
                                    modalCtrl.downloading = false;
                                    modalCtrl.downloadProgress = 0;
                                    return;
                                }
                                modalCtrl.downloadProgress = index + 1;
                                modalCtrl.downloadFile(modalCtrl.docs[index]).then(
                                    function () {
                                        $timeout(function () { downloadNext(index + 1); }, 0);
                                    },
                                    function () {
                                        if (confirm("Hubo un error. ¿Deseas continuar con el siguiente archivo?")) {
                                            $timeout(function () { downloadNext(index + 1); }, 500);
                                        } else {
                                            modalCtrl.downloading = false;
                                            modalCtrl.downloadProgress = 0;
                                        }
                                    }
                                );
                            };
                            downloadNext(0);
                        };
                    }
                ],
                controllerAs: "modal",
                size: "md",
                windowClass: "dialog",
                bindToController: true,
                resolve: {
                    docs: () => docs,
                },
            });
        };

        this.openFieldDetails = function (validationRow, fieldColumn) {
            const fieldId = fieldColumn?.id;
            const fieldDef = this.lookupFieldDefinition(fieldId, this.fieldDefMap) || fieldColumn?.fieldDef;
            const validationPayload = validationRow?.payload || {};
            const cleanFieldId = (fieldId || "").replace(/^validate_/, "");
            const payloadEntry = this.getValidationPayloadEntry(validationRow, fieldColumn);

            const resolveSubFieldDisplayValue = (subFieldData, nodeDef) => {
                if (subFieldData == null) return "";
                if (typeof subFieldData !== "object") return subFieldData;
                if (subFieldData.type === "group" && !Object.prototype.hasOwnProperty.call(subFieldData, "value")) {
                    return "";
                }
                if (Object.prototype.hasOwnProperty.call(subFieldData, "value")) {
                    const nodeFieldDef = nodeDef || this.lookupFieldDefinition(subFieldData.id, this.fieldDefMap);
                    return this.formatFieldValueForDisplay(subFieldData, nodeFieldDef);
                }
                return subFieldData.name || subFieldData.label || subFieldData.uri || JSON.stringify(subFieldData);
            };

            if (this.isNestedFieldData(fieldDef, payloadEntry)) {
                const subItems = this.extractSubItems(payloadEntry);
                const columnInfo = this.buildSimpleListDetailColumns(fieldDef, subItems);
                const subColumns = columnInfo.subColumns;
                const normalizedNodeMap = columnInfo.normalizedNodeMap;

                const normalizeText = (txt) => (txt || "")
                    .toString()
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, " ")
                    .trim();

                const getSubFieldDataByColumn = (subItem, colId) => {
                    if (!subItem || typeof subItem !== "object") return undefined;
                    if (subItem[colId] != null) return subItem[colId];

                    const cleanColId = (colId || "").replace(/^validate_/, "");
                    const prefixedColId = "validate_".concat(cleanColId);
                    if (subItem[cleanColId] != null) return subItem[cleanColId];
                    if (subItem[prefixedColId] != null) return subItem[prefixedColId];

                    // Algunos payloads vienen envueltos dentro de `value`.
                    if (subItem.value && typeof subItem.value === "object") {
                        if (subItem.value[colId] != null) return subItem.value[colId];
                        if (subItem.value[cleanColId] != null) return subItem.value[cleanColId];
                        if (subItem.value[prefixedColId] != null) return subItem.value[prefixedColId];
                    }

                    // Fallback: matcheo por id limpio (con/sin prefijo validate_)
                    const keys = Object.keys(subItem);
                    const matchedKey = keys.find(key => key.replace(/^validate_/, "") === cleanColId);
                    if (matchedKey) return subItem[matchedKey];

                    if (subItem.value && typeof subItem.value === "object") {
                        const valueKeys = Object.keys(subItem.value);
                        const matchedValueKey = valueKeys.find(key => key.replace(/^validate_/, "") === cleanColId);
                        if (matchedValueKey) return subItem.value[matchedValueKey];
                    }

                    return undefined;
                };

                const subItemsFormatted = subItems.map(subItem => {
                    const row = {};
                    subColumns.forEach(col => {
                        let subFieldData = getSubFieldDataByColumn(subItem, col.id);

                        // Fallback semántico por label/name del nodo contra metadata del subcampo
                        if (subFieldData == null && subItem && typeof subItem === "object") {
                            const colDef = normalizedNodeMap[col.id] || {};
                            const targetNames = [
                                normalizeText(colDef.name),
                                normalizeText(colDef.label),
                                normalizeText(col.label),
                            ].filter(Boolean);

                            const keys = Object.keys(subItem);
                            const matchedKeyByLabel = keys.find(key => {
                                const candidate = subItem[key];
                                if (!candidate || typeof candidate !== "object") return false;
                                const candidateNames = [
                                    normalizeText(candidate.name),
                                    normalizeText(candidate.label),
                                    normalizeText(candidate.title),
                                ].filter(Boolean);
                                return candidateNames.some(name => targetNames.includes(name));
                            });

                            if (matchedKeyByLabel) {
                                subFieldData = subItem[matchedKeyByLabel];
                            }
                        }

                        if (subFieldData == null) {
                            row[col.id] = "";
                        } else {
                            row[col.id] = resolveSubFieldDisplayValue(
                                subFieldData,
                                normalizedNodeMap[col.id] || this.lookupFieldDefinition(col.id, this.fieldDefMap)
                            );
                        }
                    });
                    return row;
                });

                $uibModal.open({
                    animation: true,
                    templateUrl: "directives/validateHistoryFieldDetailsModal.html",
                    controller: ["$uibModalInstance", "field", "modalTitle", "subColumns", "subItemsFormatted",
                        function ($uibModalInstance, field, modalTitle, subColumns, subItemsFormatted) {
                            var _this = this;
                            this.field = field;
                            this.modalTitle = modalTitle;
                            this.subColumns = subColumns || [];
                            this.subItemsFormatted = subItemsFormatted || [];

                            this.close = function () {
                                $uibModalInstance.dismiss();
                            };
                        }
                    ],
                    controllerAs: "modal",
                    size: "xlg",
                    windowClass: "dialog",
                    bindToController: true,
                    resolve: {
                        field: () => fieldDef,
                        modalTitle: () => fieldColumn?.label || fieldDef?.name || fieldDef?.label || "Detalle",
                        subColumns: () => subColumns,
                        subItemsFormatted: () => subItemsFormatted,
                    }
                });
                return;
            }

            // Fallback: mostramos el payload crudo
            $uibModal.open({
                animation: true,
                templateUrl: "directives/validateHistoryFieldDetailsModal.html",
                controller: ["$uibModalInstance", "field", "modalTitle", "rawValue",
                    function ($uibModalInstance, field, modalTitle, rawValue) {
                        var _this = this;
                        this.field = field;
                        this.modalTitle = modalTitle;
                        this.rawValue = rawValue;
                        this.subColumns = [];
                        this.subItemsFormatted = [];
                        this.close = function () {
                            $uibModalInstance.dismiss();
                        };
                    }
                ],
                controllerAs: "modal",
                size: "xlg",
                windowClass: "dialog",
                bindToController: true,
                resolve: {
                    field: () => fieldDef || {},
                    modalTitle: () => fieldColumn?.label || fieldDef?.name || fieldDef?.label || "Detalle",
                    rawValue: () => this.formatFieldValueForDisplay(payloadEntry, fieldDef || {}),
                }
            });
        };

        this.close = function () {
            $uibModalInstance.dismiss();
        };
    }
];
